import { trans } from "@mongez/localization";
import { TheSectorsSectionBG } from "../../SubsidiariesContent";
import { ImpactAreaCard } from "./ImpactAreaCard";

/**
 * Impact areas component
 * Displays different areas where the company makes an impact
 */
export function ImpactAreas() {
  const impactAreas = [
    {
      title: trans("healthTitle"),
      items: [
        trans("healthItem1"),
        trans("healthItem2"),
        trans("healthItem3"),
        trans("healthItem4"),
      ],
    },
    {
      title: trans("employmentTitle"),
      items: [
        trans("employmentItem1"),
        trans("employmentItem2"),
        trans("employmentItem3"),
        trans("employmentItem4"),
      ],
    },
    {
      title: trans("educationTitle"),
      items: [
        trans("educationItem1"),
        trans("educationItem2"),
        trans("educationItem3"),
        trans("educationItem4"),
      ],
    },
    {
      title: trans("environmentTitle"),
      items: [
        trans("environmentItem1"),
        trans("environmentItem2"),
        trans("environmentItem3"),
        trans("environmentItem4"),
        trans("environmentItem5"),
      ],
    },
    {
      title: trans("communityTitle"),
      items: [
        trans("communityItem1"),
        trans("communityItem2"),
        trans("communityItem3"),
        trans("communityItem4"),
      ],
    },
    {
      title: trans("faithTitle"),
      items: [
        trans("faithItem1"),
      ],
    },
  ];

  return (
    <div className="relative mt-8 w-full py-8 sm:mt-10 sm:py-10 md:py-12 lg:mt-8 lg:py-10 xl:mt-10 xl:py-12 3xl:mt-12 3xl:py-16">
      <TheSectorsSectionBG />

      <div className="container">
        {/* Header */}
        <h2 className="relative z-10 mb-6 text-xl font-bold text-white sm:mb-8 sm:text-2xl lg:mb-6 lg:text-2xl xl:mb-8 2xl:text-3xl 3xl:mb-10 3xl:text-3xl">
          {trans("impactAreasTitle")}
        </h2>

        {/* Grid of Impact Areas */}
        <div className="grid grid-cols-1 gap-6 sm:gap-8 lg:grid-cols-2 md:gap-10 lg:gap-8 xl:gap-10 3xl:gap-12">
          {impactAreas.map((area, index) => (
            <ImpactAreaCard key={index} title={area.title} items={area.items} />
          ))}
        </div>
      </div>
    </div>
  );
}
